import { alpha } from '@mui/material/styles';
import { brandThemeRawColors, designTokens } from '../../design-system';
import type { AbsenceTypeDisplayColor } from './model';

export const absenceTypeColorOptions: ReadonlyArray<{ value: AbsenceTypeDisplayColor; label: string }> = [
  { value: 'BLUE', label: '파랑' }, { value: 'GREEN', label: '초록' }, { value: 'PURPLE', label: '보라' },
  { value: 'ORANGE', label: '주황' }, { value: 'PINK', label: '분홍' }, { value: 'GRAY', label: '회색' },
];

type AbsenceTypeColor = { label: string; color: string; background: string; border: string };

const typeColors: Record<AbsenceTypeDisplayColor, AbsenceTypeColor> = {
  BLUE: { label: '파랑', color: designTokens.color.infoDark, background: designTokens.color.infoSoft, border: designTokens.color.infoDark },
  GREEN: { label: '초록', color: designTokens.color.successText, background: designTokens.color.successSoft, border: designTokens.color.successText },
  PURPLE: { label: '보라', color: brandThemeRawColors.preset.royalViolet.primary, background: alpha(brandThemeRawColors.preset.royalViolet.primary, 0.08), border: brandThemeRawColors.preset.royalViolet.primary },
  ORANGE: { label: '주황', color: designTokens.color.warningDark, background: designTokens.color.warningSoft, border: designTokens.color.warningDark },
  PINK: { label: '분홍', color: brandThemeRawColors.preset.burgundy.primary, background: designTokens.color.dangerSoft, border: brandThemeRawColors.preset.burgundy.primary },
  GRAY: { label: '회색', color: designTokens.color.secondaryText, background: designTokens.color.subtleSurface, border: designTokens.color.secondaryText },
};

export function getAbsenceTypeColor(displayColor?: string | null): AbsenceTypeColor {
  return displayColor && Object.hasOwn(typeColors, displayColor) ? typeColors[displayColor as AbsenceTypeDisplayColor] : typeColors.BLUE;
}
